"use strict";

var _createForOfIteratorHelper = require("/home/dev56/soham/..................../auto-dl-admin-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");
var _slicedToArray = require("/home/dev56/soham/..................../auto-dl-admin-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _react = require("react");
var _react2 = _interopRequireDefault(_react);
var _validators = require("./validators.js");
var _validators2 = _interopRequireDefault(_validators);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
exports.default = function (question, onChangeAnswer, backupAnswer) {
  var _question$validators = question.validators,
    validators = _question$validators === void 0 ? [] : _question$validators,
    _question$defaultAnsw = question.defaultAnswer,
    defaultAnswer = _question$defaultAnsw === void 0 ? backupAnswer : _question$defaultAnsw;
  var _ref = (0, _react.useState)({
      answer: defaultAnswer,
      error: null
    }),
    _ref2 = _slicedToArray(_ref, 2),
    state = _ref2[0],
    changeState = _ref2[1];
  return [state, function (newAnswer) {
    var _iterator = _createForOfIteratorHelper(validators),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var validator = _step.value;
        if (!(0, _validators2.default)(validator, newAnswer)) {
          changeState({
            answer: newAnswer,
            error: validator.text || "Invalid input, please correct!"
          });
          return;
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    var isNumeric = validators.map(function (v) {
      return v.type;
    }).includes("numeric");
    if (typeof newAnswer === "string" && isNumeric) {
      onChangeAnswer(parseFloat(newAnswer));
    } else {
      onChangeAnswer(newAnswer);
    }
    changeState({
      answer: newAnswer,
      error: null
    });
  }];
};